import React from "react";
import getPathLabels from "./getPathLabels";

const RenderFilterTree = ({
  data,
  filters,
  displayFullPathForSearch,
  searchTerm,
  handleFiltered,
  RenderNode,
  expandedNodes,
  handleToggle,
  getDeduplicatedSearchResults,
  renderSelectedFilters,
  showSearch,
  setSearchTerm,
  filterLevel // <-- new prop
}) => {
  // Helper: count how many filterable levels are currently set (active)
  function countActiveFilterLevels(nodes) {
    let activeLevels = new Set();
    function traverse(node, depth) {
      if (node.currentIsFilterable && node.activated) {
        activeLevels.add(depth);
      }
      if (node.children && node.children.length > 0) {
        node.children.forEach(child => traverse(child, depth + 1));
      }
    }
    nodes.forEach(node => traverse(node, 1));
    return activeLevels.size;
  }

  const activeFilterLevels = countActiveFilterLevels(data);

  return (
    <div>
      {renderSelectedFilters()}
      {activeFilterLevels < (filterLevel || 0) && (
        <>
          {showSearch && (
            <input
              type="text"
              placeholder="Søk i delenavn"
              value={searchTerm}
              onChange={e => setSearchTerm(e.target.value)}
              style={{ marginBottom: 8 }}
            />
          )}
          {showSearch && searchTerm ? (
            // Show flat search results when searching
            <div>
              {(() => {
                const searchResults = getDeduplicatedSearchResults();
                // Sort search results by node.text
                searchResults.sort((a, b) => a.node.text.localeCompare(b.node.text));
                return searchResults.length === 0 ? (
                  <div style={{ padding: 8 }}>Ingen treff</div>
                ) : (
                  searchResults.map(({ node, nodePath, pathArray }) => {
                    const isActive = node.currentIsFilterable && node.activated;
                    const labels = getPathLabels(data, pathArray);
                    return (
                      <div className="filter-node leaf" key={nodePath} style={{ marginLeft: 16, display: 'flex', alignItems: 'center' }}>
                        <a
                          href={(() => {
                            if (!node.fieldname) return '#';
                            const newFilters = { ...filters, [node.fieldname]: node.text, start: 1 };
                            const cleaned = Object.fromEntries(Object.entries(newFilters).filter(([_, v]) => v != null && v !== ""));
                            const params = new URLSearchParams(cleaned).toString();
                            return `?${params}`;
                          })()}
                          onClick={(e) => {
                            if (e.ctrlKey || e.metaKey || e.shiftKey || e.button === 1) {
                              return;
                            }
                            e.preventDefault();
                            handleFiltered(node, nodePath, !isActive);
                          }}
                          style={{
                            fontWeight: isActive ? 'bold' : 'normal',
                            color: isActive ? '#1976d2' : undefined,
                            textDecoration: 'underline',
                            cursor: 'pointer',
                            marginRight: 8
                          }}
                        >
                          {node.text}
                        </a>
                        {displayFullPathForSearch && (
                          <span style={{ fontSize: '0.9em', color: '#666' }}>
                            {labels.join(' > ')}
                          </span>
                        )}
                      </div>
                    );
                  })
                );
              })()}
            </div>
          ) : (
            // Show tree view when not searching
            // Sort top-level nodes by text
            (() => {
              const sortedData = [...data].sort((a, b) => a.text.localeCompare(b.text));
              return sortedData.map((node, idx) => (
                <RenderNode
                  key={idx}
                  node={node}
                  nodePath={String(idx)}
                  expandedNodes={expandedNodes}
                  onToggle={handleToggle}
                />
              ));
            })()
          )}
        </>
      )}
    </div>
  );
};

export default RenderFilterTree;
